import { BiteLogParPayEvent } from './bite_log_par_pay_event.js';

export function name(event: BiteLogParPayEvent): string {
  switch (event) {
    case BiteLogParPayEvent.None:
      return 'ok';
    case BiteLogParPayEvent.TerminalConnected:
      return 'terminal-connected';
    case BiteLogParPayEvent.TerminalDisconnected:
      return 'terminal-disconnected';
    case BiteLogParPayEvent.SaleTransaction:
      return 'sale-transaction';
    case BiteLogParPayEvent.SaleTransactionError:
      return 'sale-transaction-error';
    case BiteLogParPayEvent.DeviceSetup:
      return 'device-setup';
    case BiteLogParPayEvent.CloseTransaction:
      return 'close-transaction';
    case BiteLogParPayEvent.CloseTransactionError:
      return 'close-transaction-error';
    case BiteLogParPayEvent.NativeTransaction:
      return 'native-transaction';
    case BiteLogParPayEvent.NativeRefundTransaction:
      return 'native-refund-transaction';
    case BiteLogParPayEvent.RefundTransactionRequested:
      return 'refund-transaction-requested';
    case BiteLogParPayEvent.RefundTransaction:
      return 'refund-transaction';
    case BiteLogParPayEvent.RefundTransactionError:
      return 'refund-transaction-error';
    case BiteLogParPayEvent.Logs:
      return 'logs';
    case BiteLogParPayEvent.CardBinRequest:
      return 'card-bin-request';
    case BiteLogParPayEvent.CardBinRequestError:
      return 'card-bin-request-error';
    case BiteLogParPayEvent.TerminalRebootRequested:
      return 'terminal-reboot-requested';
    case BiteLogParPayEvent.TerminalRebootSkipped:
      return 'terminal-reboot-skipped';
  }
}
